import React from "react";
import FAQimg from "../../../assets/Dashboard/FAQimg.png";
import Envelope from "../../../assets/Dashboard/Envelope.png";

const HelpAndSupport = () => {
  return (
    <div>
      <div className="flex items-center gap-[32px] mt-[48px]">
        <h1 className="text-[48px] font-[600]">Frequently asked question</h1>
        <img src={FAQimg} alt="FAQimg" />
      </div>
      <div className=" grid grid-cols-3 gap-[24px] mt-[42px]">
        <div>
          <img
            style={{ boxShadow: "0px 0px 12px 0px #3E4DAC" }}
            className="p-[11px] rounded-full"
            src={Envelope}
            alt="Envelope"
          />
          <h1 className="pt-[43px] text-[#6278FF] text-[20px] font-[700]">
            What are lab points ?
          </h1>
          <p className="pt-[24px] text-[16px]">
            Lab points are a digital currency that you earn by completing tasks
            and activities within the platform. They can be redeemed for various
            rewards and benefits.
          </p>
        </div>
        <div>
          <img
            style={{ boxShadow: "0px 0px 12px 0px #3E4DAC" }}
            className="p-[11px] rounded-full"
            src={Envelope}
            alt="Envelope"
          />
          <h1 className="pt-[43px] text-[#6278FF] text-[20px] font-[700]">
            What are lab points ?
          </h1>
          <p className="pt-[24px] text-[16px]">
            Lab points are a digital currency that you earn by completing tasks
            and activities within the platform. They can be redeemed for various
            rewards and benefits.
          </p>
        </div>
        <div>
          <img
            style={{ boxShadow: "0px 0px 12px 0px #3E4DAC" }}
            className="p-[11px] rounded-full"
            src={Envelope}
            alt="Envelope"
          />
          <h1 className="pt-[43px] text-[#6278FF] text-[20px] font-[700]">
            What are lab points ?
          </h1>
          <p className="pt-[24px] text-[16px]">
            Lab points are a digital currency that you earn by completing tasks
            and activities within the platform. They can be redeemed for various
            rewards and benefits.
          </p>
        </div>
        <div>
          <img
            style={{ boxShadow: "0px 0px 12px 0px #3E4DAC" }}
            className="p-[11px] rounded-full"
            src={Envelope}
            alt="Envelope"
          />
          <h1 className="pt-[43px] text-[#6278FF] text-[20px] font-[700]">
            What are lab points ?
          </h1>
          <p className="pt-[24px] text-[16px]">
            Lab points are a digital currency that you earn by completing tasks
            and activities within the platform. They can be redeemed for various
            rewards and benefits.
          </p>
        </div>
        <div>
          <img
            style={{ boxShadow: "0px 0px 12px 0px #3E4DAC" }}
            className="p-[11px] rounded-full"
            src={Envelope}
            alt="Envelope"
          />
          <h1 className="pt-[43px] text-[#6278FF] text-[20px] font-[700]">
            What are lab points ?
          </h1>
          <p className="pt-[24px] text-[16px]">
            Lab points are a digital currency that you earn by completing tasks
            and activities within the platform. They can be redeemed for various
            rewards and benefits.
          </p>
        </div>
        <div>
          <img
            style={{ boxShadow: "0px 0px 12px 0px #3E4DAC" }}
            className="p-[11px] rounded-full"
            src={Envelope}
            alt="Envelope"
          />
          <h1 className="pt-[43px] text-[#6278FF] text-[20px] font-[700]">
            What are lab points ?
          </h1>
          <p className="pt-[24px] text-[16px]">
            Lab points are a digital currency that you earn by completing tasks
            and activities within the platform. They can be redeemed for various
            rewards and benefits.
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpAndSupport;
